module.exports = __webpack_public_path__ + "img/Ulises Villegas_Diseño.750b6671.png";